import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const check = (surveyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.CHECK_SURVEY_REQUEST });

  return api.authorization.survey.check(surveyId)
    .then((res: any) => {

      dispatch({
        type: types.CHECK_SURVEY_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.CHECK_SURVEY_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
  
export const getQuestions = (surveyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_SURVEY_QUESTIONS_REQUEST });

  return api.authorization.survey.getQuestions(surveyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_SURVEY_QUESTIONS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_SURVEY_QUESTIONS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
  
export const save = (surveyId: number, contactPerson: string, contactPhone: string, answers: any, answerTexts: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.authSurvey.isSaving) { return Promise.reject(); }

  dispatch({ type: types.SAVE_SURVEY_REQUEST });

  const model = {
    "SurveyId": surveyId,
    "ContactPerson": contactPerson,
    "ContactPhone": contactPhone,
    "Answers": answers,
    "AnswerTexts": answerTexts
  };

  return api.authorization.survey.save(model)
    .then((res: any) => {

      dispatch({
        type: types.SAVE_SURVEY_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.SAVE_SURVEY_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};